export var RelativeSelectionPos;
(function (RelativeSelectionPos) {
  RelativeSelectionPos["Before"] = "Before";
  RelativeSelectionPos["Start"] = "Start";
  RelativeSelectionPos["Inside"] = "Inside";
  RelativeSelectionPos["End"] = "End";
})(RelativeSelectionPos || (RelativeSelectionPos = {}));